import { SoftwareReleaseService } from "@app/software-releases";
import { JSX, PureComponent } from "react";
import { QESButton, QESSelect } from "@app/shared/qes-standards";
import { FlyoutContextOutgoingProps, FlyoutFooter, withFlyoutContext } from "@app/shared/Flyouts";

interface CreateSoftwareReleasePanelProps {
  handleConfirm: (result: string) => void,
}

interface CreateSoftwareReleasePanelState {
  releaseVersionOptions: JSX.Element[];
  selectedReleaseVersion: string;
  formIsValid: boolean;
}


class WrappedCreateSoftwareReleasePanelContent extends PureComponent<CreateSoftwareReleasePanelProps & FlyoutContextOutgoingProps, CreateSoftwareReleasePanelState> {

  constructor(props: CreateSoftwareReleasePanelProps & FlyoutContextOutgoingProps) {
    super(props);
    this.state = {
      formIsValid: false,
      releaseVersionOptions: [],
      selectedReleaseVersion: null,
    };
  }

  private softwareReleaseService = new SoftwareReleaseService();

  public async componentDidMount() {
    const unallocatedReleases = await this.softwareReleaseService.getUnallocatedReleases();
    this.setState({
      releaseVersionOptions: [<option value="-1" key="-1">Select a Release Version</option>, ...unallocatedReleases.map(r => <option value={r} key={r}>{r}</option>)]
    });
  }

  public render() {
    return (
      <>
        <div className="row mt-3">
          <div className="col-12">
            <QESSelect
              containerClassName="col-10 mb-3"
              label="Release Version"
              testId="new-release_release-version"
              onChange={this.handleReleaseVersionChange}
            >
              {this.state.releaseVersionOptions}
            </QESSelect>
          </div>
        </div>
        <FlyoutFooter
          submitButton={
            <QESButton
              qesTestId="create-software-release-panel-content_confirm"
              disabled={!this.state.formIsValid}
              onClick={() => { this.props.handleConfirm(this.state.selectedReleaseVersion); this.props.handleCloseFlyout(); }}
            >
              Create
            </QESButton>}
        />
      </>
    );
  }

  private handleReleaseVersionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedReleaseVersion = e.target.value;
    const formIsValid = !!selectedReleaseVersion && selectedReleaseVersion != "-1";

    this.setState((prevState) => ({
      ...prevState,
      formIsValid,
      selectedReleaseVersion,
    }));
  }
}

const CreateSoftwareReleasePanelContent = withFlyoutContext(WrappedCreateSoftwareReleasePanelContent);
export default CreateSoftwareReleasePanelContent;
